import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSession } from '../firebase/UserProvider';
import { firestore } from '../firebase/config'; // requestFirebaseNotificationPermission
import { updateUserDocument, addUserReading } from '../firebase/user';
//import { ProfileImage } from '../ProfileImage';
import { RiMailSendLine } from 'react-icons/ri';
import SideMenu from '../SideMenu';
import JoinForm from '../components/JoinForm';
import { siteCode, siteLogo, doctors } from '../components/Doctors'
import { sampleReadings } from '../components/sampleReadings'
import "./Profile.scss";

function Profile(props) {
  const { user } = useSession();
  const params = useParams();
  const { register, setValue, handleSubmit } = useForm();
  const [userDocument, setUserDocument] = useState(null);
  const [isLoading, setLoading] = useState(false);

  // const launchReading = async () => {
  //   props.history.push(`/reading/${params.id}`);
  // };

  useEffect(() => {
    const docRef = firestore.collection('users').doc(params.id);
    const unsubscribe = docRef.onSnapshot((doc) => {
      if (doc.exists) {
        const documentData = doc.data();
        setUserDocument(documentData);
        const formData = Object.entries(documentData).map((entry) => ({
          [entry[0]]: entry[1],
        }));
        setValue(formData);
      }
    });
    return unsubscribe;
  }, [!!user && user.uid, setValue, params.id]);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      //console.log('Passwd...: ',state)
      if (data?.doctor?.substring(0, 6) === "Demo: ") {
        const diffDevices = data.devices.filter(x => !userDocument.devices.includes(x));
        diffDevices.forEach(deviceType => {
          const samples = sampleReadings(data.doctor, deviceType, 10)
          console.log('userDocument', userDocument, '\ndata', data, '\ndiffDevices', diffDevices, '\nsampleReadings', samples)

          addUserReading({ uid: params.id, adds: samples });

          //     if ( ! data?.demo?.includes(element) ) {
          //       data.demo.push(element)

          //     }
        })
      }

      await updateUserDocument({ uid: params.id, ...data });
      if (data.devices[0]) {
        props.history.push(`/reading/${params.id}`);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  if (!userDocument) {
    return null;
  }

  const formClassname = `ui big form twelve wide column ${isLoading ? 'loading' : ''}`;

  return (
    <>
      {" "}
      <SideMenu id={params.id} profile />

      {" "}

      <div className="profile__container">
        <div className="profile__header">
          <img src={siteLogo} alt={siteCode} height="40" />
          <h1 className="profile__title">Profile</h1>
          <div>
          </div>
        </div>

        <form className={`ui form ${isLoading ? 'loading' : ''} profile__form`} onSubmit={handleSubmit(onSubmit)}>
          <div className="profile__grid">
            <div className='profile__fullWidth'>
            <div className="profile___submit-container">
            <button type="submit" className="profile___submit">Submit</button>
          </div>
              <div className="">
                <label key="doctors" htmlFor="doctor" className="profile__label">
                  Health Care Provider
                </label>
                <div className="profile__select-wrapper">

                  <select id="doctor" name="doctor" className="profile__select" ref={register}>
                    {doctors.map((doctor) => (
                      <option key={doctor.label} value={doctor.value}>{doctor.label}</option>
                    ))}
                  </select>
                  <svg
                    className="profile__icon"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                      clipRule="evenodd"
                    />
                  </svg>

                </div>
              </div>
            </div>
            <div className='profile__fullWidth'>
              {(userDocument.devices?.length) ? '' : `Hi ${userDocument.name}, Please select your medical device(s) and update your information, and then at the end of this page [Submit] your Profile updates.`}
            </div>
            <div className="profile__fullWidth">
              <fieldset className="profile__notifications">
                <legend className="profile__sr-only">Medical Device</legend>
                <div className="profile__notification-options">

                  <div className="profile__checkbox-item">
                    <div className="profile__checkbox-wrapper">
                      <div className="profile__custom-checkbox-group">
                        <input
                          id="bloodPressureMonitor"
                          name="devices"
                          type="checkbox"
                          value="bloodPressureMonitor"
                          ref={register}
                          aria-describedby="blood-pressure-monitor"
                          className="profile__checkbox"
                        />
                        <svg
                          className="profile__checkbox-icon"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            className="profile__checkbox-check"
                            d="M3 8L6 11L11 3.5"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            className="profile__checkbox-indeterminate"
                            d="M3 7H11"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="profile__label-container">
                      <label htmlFor="bloodPressureMonitor" className="profile__label">
                        Blood Pressure Monitor
                      </label>
                      <span id="blood-pressure-monitor" className="profile__description">
                        <span className="profile__sr-only">Blood Pressure Monitor </span>
                      </span>
                    </div>
                  </div>

                  <div className="profile__checkbox-item">
                    <div className="profile__checkbox-wrapper">
                      <div className="profile__custom-checkbox-group">
                        <input
                          id="bloodGlucoseMeter"
                          name="devices"
                          type="checkbox"
                          ref={register}
                          value="bloodGlucoseMeter"
                          aria-describedby="blood-glucose-meter"
                          className="profile__checkbox"
                        />
                        <svg
                          className="profile__checkbox-icon"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            className="profile__checkbox-check"
                            d="M3 8L6 11L11 3.5"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            className="profile__checkbox-indeterminate"
                            d="M3 7H11"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="profile__label-container">
                      <label htmlFor="bloodGlucoseMeter" className="profile__label">
                        Blood Glucose Meter
                      </label>
                      <span id="blood-glucose-meter" className="profile__description">
                        <span className="profile__sr-only">Blood Glucose Meter</span>
                      </span>
                    </div>
                  </div>

                  <div className="profile__checkbox-item">
                    <div className="profile__checkbox-wrapper">
                      <div className="profile__custom-checkbox-group">
                        <input
                          id="continuousGlucoseMonitor"
                          name="devices"
                          type="checkbox"
                          value="continuousGlucoseMonitor"
                          ref={register}
                          aria-describedby="continuous-glucose-monitor"
                          className="profile__checkbox"
                        />
                        <svg
                          className="profile__checkbox-icon"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            className="profile__checkbox-check"
                            d="M3 8L6 11L11 3.5"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            className="profile__checkbox-indeterminate"
                            d="M3 7H11"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="profile__label-container">
                      <label htmlFor="continuousGlucoseMonitor" className="profile__label">
                        Continuous Glucose Monitor
                      </label>
                      <span id="continuous-glucose-monitor" className="profile__description">
                        <span className="profile__sr-only">Continuous Glucose Monitor </span>
                      </span>
                    </div>
                  </div>

                  <div className="profile__checkbox-item">
                    <div className="profile__checkbox-wrapper">
                      <div className="profile__custom-checkbox-group">
                        <input
                          id="glucoseMonitor"
                          name="devices"
                          type="checkbox"
                          value="glucoseMonitor"
                          ref={register}
                          aria-describedby="continuous-glucose-monitor"
                          className="profile__checkbox"
                        />
                        <svg
                          className="profile__checkbox-icon"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            className="profile__checkbox-check"
                            d="M3 8L6 11L11 3.5"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            className="profile__checkbox-indeterminate"
                            d="M3 7H11"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="profile__label-container">
                      <label htmlFor="glucoseMonitor" className="profile__label">
                        glucose Monitor
                      </label>
                      <span id="continuous-glucose-monitor" className="profile__description">
                        <span className="profile__sr-only">glucose Monitor </span>
                      </span>
                    </div>
                  </div>

                  <div className="profile__checkbox-item">
                    <div className="profile__checkbox-wrapper">
                      <div className="profile__custom-checkbox-group">
                        <input
                          id="peakFlowMeter"
                          name="devices"
                          type="checkbox"
                          value="peakFlowMeter"
                          ref={register}
                          aria-describedby="peak-flow-meter"
                          className="profile__checkbox"
                        />
                        <svg
                          className="profile__checkbox-icon"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            className="profile__checkbox-check"
                            d="M3 8L6 11L11 3.5"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            className="profile__checkbox-indeterminate"
                            d="M3 7H11"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="profile__label-container">
                      <label htmlFor="peakFlowMeter" className="profile__label">
                        Peak Flow Meter
                      </label>
                      <span id="peak-flow-meter" className="profile__description">
                        <span className="profile__sr-only">Peak Flow Meter</span>
                      </span>
                    </div>
                  </div>

                  <div className="profile__checkbox-item">
                    <div className="profile__checkbox-wrapper">
                      <div className="profile__custom-checkbox-group">
                        <input
                          id="fingertipPulseOximeter"
                          name="devices"
                          type="checkbox"
                          value="fingertipPulseOximeter"
                          ref={register}
                          aria-describedby="fingertip-pulse-oximeter"
                          className="profile__checkbox"
                        />
                        <svg
                          className="profile__checkbox-icon"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            className="profile__checkbox-check"
                            d="M3 8L6 11L11 3.5"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            className="profile__checkbox-indeterminate"
                            d="M3 7H11"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="profile__label-container">
                      <label htmlFor="fingertipPulseOximeter" className="profile__label">
                        Fingertip Pulse Oximeter
                      </label>
                      <span id="fingertip-pulse-oximeter" className="profile__description">
                        <span className="profile__sr-only">Fingertip Pulse Oximeter </span>
                      </span>
                    </div>
                  </div>

                  <div className="profile__checkbox-item">
                    <div className="profile__checkbox-wrapper">
                      <div className="profile__custom-checkbox-group">
                        <input
                          id="scale"
                          name="devices"
                          type="checkbox"
                          value="scale"
                          ref={register}
                          aria-describedby="scale-description"
                          className="profile__checkbox"
                        />
                        <svg
                          className="profile__checkbox-icon"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            className="profile__checkbox-check"
                            d="M3 8L6 11L11 3.5"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            className="profile__checkbox-indeterminate"
                            d="M3 7H11"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="profile__label-container">
                      <label htmlFor="scale" className="profile__label">
                        Scale
                      </label>
                      <span id="scale-description" className="profile__description">
                        <span className="profile__sr-only">Scale </span>
                      </span>
                    </div>
                  </div>

            
                </div>
              </fieldset>
            </div>




            <div className="profile__fullWidth">
              <label htmlFor="phone-number" className="profile__label">Phone number</label>
              <div className="profile__inputWrapper">
                <input type="text" name="phone" id="phone-number" className="profile__input" ref={register} placeholder="Required" />
              </div>
            </div>

            <div className="profile__fullWidth">
              <label htmlFor="dob" className="profile__label">Date Of Birth</label>
              <div className="profile__inputWrapper">
                <input type="date" name="dob" id="dob" className="profile__input" ref={register} />
              </div>
            </div>

            <div className="profile__fullWidth">
              <label htmlFor="weight" className="profile__label">Weight</label>
              <div className="profile__inputWrapper">
                <input type="text" name="weight" id="weight" className="profile__input" ref={register} placeholder="Optional" />
              </div>
            </div>

            <div className="profile__fullWidth">
              <label htmlFor="height" className="profile__label">Height</label>
              <div className="profile__inputWrapper">
                <input type="text" name="height" id="height" className="profile__input" ref={register} placeholder="Optional" />
              </div>
            </div>

            <div className='profile__fullWidth'>
              <label htmlFor="address" className="profile__label">Address</label>
              <div className="profile__inputWrapper">
                <input type="text" name="address" id="address" className="profile__input" ref={register} placeholder="Optional" />
              </div>
            </div>

            <div className='profile__fullWidth-Sm'>
              <label htmlFor="city" className="profile__label">City</label>
              <div className="profile__inputWrapper">
                <input type="text" name="city" id="city" className="profile__input" ref={register} placeholder="Optional" />
              </div>
            </div>

            <div className='profile__fullWidth-Sm'>
              <label htmlFor="state" className="profile__label">State</label>
              <div className="profile__inputWrapper">
                <input type="text" name="state" id="state" className="profile__input" ref={register} placeholder="Optional" />
              </div>
            </div>
            <div className='profile__fullWidth-Sm'>
              <label htmlFor="zip" className="profile__label">Zip</label>
              <div className="profile__inputWrapper">
                <input type="text" name="zip" id="zip" className="profile__input" ref={register} placeholder="Optional" />
              </div>
            </div>

            <div className='profile__fullWidth-Sm'>
              <label htmlFor="gender" className="profile__label">
                Gender
              </label>
              <div className="profile__select-wrapper">

                <select id="gender" name="gender" className="profile__select" placeholder="Optional" ref={register}>
                  <option value="">Optional</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
                <svg
                  className="profile__icon"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                    clipRule="evenodd"
                  />
                </svg>

              </div>
            </div>

            <div className='profile__fullWidth'>
              <JoinForm refReg={register} placeholder="Change Password" />
            </div>

            <div className='profile__fullWidth-Sm'>
              <label htmlFor="name" className="profile__label">Name</label>
              <div className="profile__inputWrapper">
                <input type="text" name="name" id="name" ref={register} className="profile__input" />
              </div>
            </div>


            <div className='profile__fullWidth-Sm'>
              <label htmlFor="email" className="profile__label">Email</label>
              <div className="profile__inputWrapper">
                <input type="text" name="email" id="email" className="profile__input" disabled ref={register} />
              </div>
            </div>


          </div>

          <div className='profile__fullWidth profile__notification-section'>
            <div className="profile__checkbox-item">
              <div className="profile__checkbox-wrapper">
                <div className="profile__custom-checkbox-group">
                  <input
                    id="receiveEmail"
                    name="receiveEmail"
                    type="checkbox"
                    value={true}
                    ref={register}
                    aria-describedby="receive-email"
                    className="profile__checkbox"
                  />
                  <svg
                    className="profile__checkbox-icon"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      className="profile__checkbox-check"
                      d="M3 8L6 11L11 3.5"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      className="profile__checkbox-indeterminate"
                      d="M3 7H11"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div className="profile__label-container">
                <label htmlFor="receiveEmail" className="profile__label">
                  <RiMailSendLine />{" "}Notifications
                </label>
                <span id="receive-email" className="profile__description">
                  <span className="profile__sr-only">Receive emails</span>
                </span>
              </div>
            </div>
          </div>
          <div className="profile___submit-container">
            <button type="submit" className="profile___submit">Submit</button>
          </div>
        </form>
      </div>

    </>
  );
};

export default Profile;
